import * as React from "react"
import type { SVGProps } from "react"
const SvgFiles = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M20 19.57H9q-.82 0-1.41-.59A2 2 0 0 1 7 17.57v-14q0-.82.59-1.41A2 2 0 0 1 9 1.57h6.18a2 2 0 0 1 1.4.57L21.42 7A2 2 0 0 1 22 8.4v9.18q0 .82-.59 1.41a2 2 0 0 1-1.41.59Zm0-11h-3.5q-.63 0-1.06-.44A1.5 1.5 0 0 1 15 7.07v-3.5H9v14h11zm-15 15q-.82 0-1.41-.59A2 2 0 0 1 3 21.57v-13q0-.42.29-.71A1 1 0 0 1 4 7.57q.42 0 .71.29.3.29.29.71v13h10q.42 0 .71.29.3.29.29.71 0 .42-.29.71a1 1 0 0 1-.71.29z" />
  </svg>
)
export default SvgFiles
